const indexItems = [
  { label: '91国产高清视频', icon: 'ri-movie-line', count: '5,280部' },
  { label: '超清视频在线观看', icon: 'ri-4k-line', count: '3,650部' },
  { label: '高清影视在线', icon: 'ri-film-line', count: '4,120部' },
  { label: '91高清视频在线', icon: 'ri-play-circle-line', count: '6,840部' },
  { label: '每日更新推荐', icon: 'ri-calendar-check-line', count: '500+/日' },
  { label: '国产精选合集', icon: 'ri-star-line', count: '2,350部' },
  { label: '热门视频排行', icon: 'ri-fire-line', count: '实时更新' },
  { label: '移动端观影', icon: 'ri-smartphone-line', count: '全适配' },
  { label: '高清视频在线播放', icon: 'ri-live-line', count: '9,200+部' },
];

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            主题索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            快速浏览91麻豆免费视频网站的全部内容主题，一键直达您感兴趣的分类
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) {
                  const headerHeight = 72;
                  const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="group flex items-center gap-4 bg-background-50 rounded-xl border border-background-200/70 p-4 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${item.icon} text-lg text-secondary-600 group-hover:text-primary-500 transition-colors duration-300`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-900 truncate">
                  {item.label}
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">
                  {item.count}
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}